import React from 'react';
import { Link } from 'gatsby';
import { chakra, Text, Th } from '@chakra-ui/react';
import { ResultsTable } from '../ui-components/ResultsTable';
import TechLibraryItemRow from './TechLibraryItemRow';

const VIDEO_MEDIA_TYPES = ['youtube', 'video'];
const VIDEO_NUMBER_PATTERN = /^(\d+)-V(\d+)$/i;

// Newest year first, then highest number first. Anything that doesn't follow the YY-V# convention sorts last.
const compareVideoNumbersDescending = (a, b) => {
  const matchA = VIDEO_NUMBER_PATTERN.exec(a.calledby || '');
  const matchB = VIDEO_NUMBER_PATTERN.exec(b.calledby || '');

  if (!matchA || !matchB) {
    return Number(Boolean(matchB)) - Number(Boolean(matchA));
  }

  const yearDifference = Number(matchB[1]) - Number(matchA[1]);

  return yearDifference || Number(matchB[2]) - Number(matchA[2]);
};

const VideoLibrary = ({ bulletins, onOpen }) => {
  const videos = bulletins
    .filter((item) => VIDEO_MEDIA_TYPES.includes(item.media_type?.toLowerCase()))
    .sort(compareVideoNumbersDescending);

  const tableHeaders = (
    <>
      <Th className="w-40 min-w-24">Number</Th>
      <Th className="w-40 min-w-24">Make</Th>
      <Th className="min-w-36">Description</Th>
    </>
  );

  return (
    <>
      <chakra.h1 className="mb-4 uppercase text-l md:text-xxl text-darkBlue">Video Library</chakra.h1>
      <Text className="mb-6" sx={{ a: { textDecoration: 'underline' } }}>
        <Link to="/tech-library">Back to Tech Library</Link>
      </Text>
      <ResultsTable sx={{ tr: { display: 'block' } }} headers={tableHeaders}>
        {videos.map((item) => (
          <TechLibraryItemRow key={item.id} item={item} onOpen={onOpen} />
        ))}
      </ResultsTable>
    </>
  );
};

export default VideoLibrary;
